import React, { useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import FornecedorSidebar from './sidebar';
import CriarFornecedor from './criarfornecedor';
import ConsultarFornecedor from './consultarfornecedor';

const FornecedorLayout = () => {
    const [selectedOption, setSelectedOption] = useState('');
    const [sidebarVisible, setSidebarVisible] = useState(true);

    const handleOptionChange = (option) => {
        setSelectedOption(option);
    };

    const renderContent = () => {
        switch (selectedOption) {
            case 'criar':
                return <CriarFornecedor />;
            case 'consultar':
                return <ConsultarFornecedor />;
            default:
                return (
                    <Typography variant="body1" align="center">
                        Selecione uma opção no menu.
                    </Typography>
                );
        }
    };

    return (
        <Box sx={{ display: 'flex', height: '100vh' }}>
            {sidebarVisible && (
                <Box
                    sx={{
                        width: '300px',
                        borderRight: '1px solid #ccc',
                        position: 'relative'
                    }}
                >
                    <FornecedorSidebar onOptionChange={handleOptionChange} />
                    {/* Botão para esconder o sidebar */}
                    <IconButton
                        onClick={() => setSidebarVisible(false)}
                        sx={{
                            position: 'absolute',
                            top: '10px',
                            right: '-20px',
                            backgroundColor: 'white',
                            boxShadow: 1
                        }}
                    >
                        <ChevronLeftIcon />
                    </IconButton>
                </Box>
            )}
            {/* Quando o sidebar estiver oculto, exibe um botão para mostrá-lo */}
            {!sidebarVisible && (
                <IconButton
                    onClick={() => setSidebarVisible(true)}
                    sx={{
                        position: 'absolute',
                        left: '0px',
                        top: '50%',
                        backgroundColor: 'white',
                        boxShadow: 1,
                        zIndex: 1
                    }}
                >
                    <ChevronRightIcon />
                </IconButton>
            )}
            <Box sx={{ flexGrow: 1, p: 2 }}>
                {renderContent()}
            </Box>
        </Box>
    );
};

export default FornecedorLayout;
